 <template>
  <v-row>
    <v-col class="text-center">
      <v-btn class="ma-2" tile outlined color="primary" @click="$emit('back')">
        <v-icon left>mdi-arrow-left</v-icon>
        {{$t('DataHome.back')}}
      </v-btn>
    </v-col>
  </v-row>
  
</template>

<script>
export default {};
</script>
